import { BranchStatusEnum } from '@/rtkApi/mddApiSliceGeneratedV2'

export type BranchStatus = BranchStatusEnum

export type BranchRecord = {
	createdAt: string
	createdBy: string
	description: string
	id: string
	name: string
	protectedBranch?: boolean
	requireExplicitMergeAction?: boolean
	requiredApprovals?: number
	restrictToExplicitPermissions?: boolean
	selfApprovalAllowed?: boolean
	sourceBranchId: string | null
	sourceBranchName: string | null
	sourceReleaseId: number | null
	status: BranchStatus
	system: string
	updatedAt: string
	updatedBy: string
}

export const BRANCH_LIST_PAGE_SIZE = 200

export const getBranchesPath = (branchId: string) =>
	`/branches/${encodeURIComponent(branchId)}`
